(function () {

  'use strict';

  function pxNetworkPropertiesContextMenu(
    $timeout, $window, CopilotService
    ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        resource: '=resource',
        auxiliaries: '=auxiliaries',
        selectedTab: '=selectedTab',
        contextPosition: '=contextPosition',
        callback: '&callback',
        updateParent: '&updateParent'
      },
      // TEMPLATE USAGE -> px-on-device-config-context-menu // APPROVED
      templateUrl: 'app/components/networkProperties/_networkPropertiesContextMenu/_networkPropertiesContextMenu.template.html',
      link: function (scope, element, attrs) {


        (function() {
          initContexContent();
        })();

        scope.$watch(function() {
          return scope.contextPosition;
        }, function(oldVal, newVal){
          if (oldVal !== newVal) {
            initContexContent();
          }
        })

        function initContexContent() {
          checkValidPostion (scope.contextPosition.left, scope.contextPosition.top) 
        };

        function checkValidPostion (left, top) {
          $timeout(function() {
            var menuHeight = angular.element('.context-content-container').innerHeight();
            var menuWidth = angular.element('.context-content-container').innerWidth();


            var screenVertCenter = $window.innerHeight / 2;
            var menuVerticalCenter = menuHeight / 2;
            top = screenVertCenter - menuVerticalCenter;

            var screenHorCenter = CopilotService.getAvailableWidth() / 2
            var menuHorizontalCenter = menuWidth / 2;

            left = screenHorCenter - menuHorizontalCenter; 


            angular.element('.context-content-container').css({left: left , top: top});
            angular.element('.context-content-container').css({display: 'block'});
          }, 50)
        }

        scope.closePopup = function (bypass) {
          if (!bypass) {
            scope.callback({selectedContextMenuItem: null, contextPosition: null, contextContent: null});
          }
        }

        scope.closePopupOnClickOutside = function (bypass) {
          // Don't close the dialog on outside click if the copilot window is open and configured
          // because the user might want to interact with the copilot window.
          const copilotOpenAndEnabled = CopilotService.state.chatOpen && CopilotService.state.configured;
          scope.closePopup(bypass || copilotOpenAndEnabled);
        }

        scope.relayUpdateParent = function () {
          scope.updateParent(); 
        }

        scope.$on('$destroy', function() {
          angular.element('.context-content-container').css({display: 'none'});
        });

      }
    }
  }



  pxNetworkPropertiesContextMenu.$inject = ['$timeout', '$window', 'CopilotService'];

  angular
    .module('printix-admin')
    .directive('pxNetworkPropertiesContextMenu', pxNetworkPropertiesContextMenu);

})();